export enum InvoiceDiscountType {
  PERCENTAGE = "PERCENTAGE",
  AMOUNT = "AMOUNT",
  CREDIT_CARD = "CREDIT_CARD",
}
